export default {
  'am.archive.banner': "Bu proje aktif katalogdan çıkarılmıştır ve arşiv kaydı olarak korunmaktadır.",
  'am.archive.note': "Fikir ileride farklı bir projeye dönüşürse bu proje için ayrı bir sayfa açılacaktır.",
  'am.archive.noteLabel': "// not",
  'am.archive.status.catalog.label': "Katalog Durumu",
  'am.archive.status.catalog.value': "Aktif Değil",
  'am.archive.status.dev.label': "Geliştirme Durumu",
  'am.archive.status.dev.value': "Durduruldu",
  'am.archive.status.restart.label': "Yeniden Başlatma",
  'am.archive.status.restart.value': "Yok",
  'am.archive.status.store.label': "Mağaza Yayını",
  'am.archive.status.store.value': "Planlanmıyor",
  'am.archive.statusLabel': "// arşiv durumu",
  'am.breadcrumb.archive': "Arşiv",
  'am.cta.button': "Oyunlara Dön",
  'am.cta.description': "Geliştirme aşamasındaki oyunlara göz at.",
  'am.cta.label': "// aktif projelere dön",
  'am.description': "Atmosfer ve hikâye odağıyla planlanan Anılar Müzesi, aktif üretim hattından çıkarıldı ve tamamen arşive alındı.",
  'am.footer.right': "Arşiv Kaydı · Aktif Değil",
  'am.name': "Anılar Müzesi",
  'am.name.line1': "Anılar",
  'am.name.line2': "Müzesi",
  'am.note.1.content': "Anılar Müzesi, oyuncunun terk edilmiş bir müzeyi gezip geçmişe ait anı parçalarını topladığı mobil oyun fikri olarak tasarlandı.",
  'am.note.1.title': "Temel Fikir",
  'am.note.2.content': "Mevcut ekip kapasitesi ve öncelikler doğrultusunda proje aktif geliştirme hattından çıkarıldı.",
  'am.note.2.title': "Neden İptal Edildi?",
  'am.note.3.content': "Eski ürün notları ve konsept bilgileri bu sayfada arşiv kaydı olarak korunmaktadır.",
  'am.note.3.title': "Arşiv Politikası",
  'am.notes.label': "// konsept notları",
  'am.notes.unit': "kayıt",
  'am.progress.label': "Geliştirme İlerlemesi",
  'am.progress.stopped': "Geliştirme Durduruldu",
  'am.timeline.1.label': "Fikir Aşaması",
  'am.timeline.1.note': "Atmosfer odaklı hikâye oyunu fikri ve anı mekaniği notları oluşturuldu.",
  'am.timeline.2.label': "Konsept Geliştirme",
  'am.timeline.2.note': "Oynanış taslakları, hikâye yapısı ve görsel atmosfer referansları çalışıldı.",
  'am.timeline.3.label': "Üretim Hattından Çıkarıldı",
  'am.timeline.3.note': "Proje aktif üretimden çıkarıldı, geliştirme durduruldu ve arşiv statüsüne alındı.",
  'am.timeline.label': "// proje zaman çizelgesi",
  'app.defterkasa.category': "Finans · Android",
  'app.defterkasa.description': "Küçük işletmeler için profesyonel muhasebe ve ön muhasebe. Tamamen çevrimdışı, bulut yok, abonelik yok.",
  'app.defterkasa.progressLabel': "Üretime Hazır",
  'app.kozmik.category': "Yaşam Tarzı · Android - iOS",
  'app.kozmik.description': "Kozmik temalı kişisel günlük. Düşüncelerini, rüyalarını ve günlük yansımalarını güzel bir uzayda yaz.",
  'app.kozmik.progressLabel': "Tahmini çıkış tarihi: 2027",
  'app.pixeldungeon.category': "RPG · Android",
  'app.pixeldungeon.description': "Roguelike unsurlarıyla sıra tabanlı piksel RPG. Zindanları keşfet, ekipman yap ve kadim patronları yen.",
  'app.pixeldungeon.progressLabel': "Konsept Aşaması",
  'app.voidrunner.category': "Arcade · Android",
  'app.voidrunner.description': "Karanlık bir boşluk evreninde geçen hızlı tempolu sonsuz koşucu. Engellerden kaç, enerji çekirdekleri topla, hayatta kal.",
  'app.voidrunner.progressLabel': "Tahmini çıkış tarihi: 2027",
  'apps.comingSoon': "Yakında",
  'apps.description': "Android ve iOS için üretkenlik ve yaşam tarzı uygulamaları. Çevrimdışı öncelikli, gizlilik odaklı, abonelik yok.",
  'apps.devProgress': "Geliştirme İlerlemesi",
  'apps.dk.description': "Küçük işletmeler için profesyonel muhasebe ve ön muhasebe.",
  'apps.dk.longDescription': "Defter Kasa, küçük işletme sahipleri, esnaflar ve serbest çalışanlar için tasarlanmış tamamen çevrimdışı bir muhasebe uygulamasıdır. Bulut yok, abonelik yok — verileriniz cihazınızda kalır. Fatura oluşturun, giderleri takip edin, müşterileri yönetin ve PDF raporları kolayca dışa aktarın.",
  'apps.dk.name': "Defter Kasa",
  'apps.dk.progressLabel': "Üretime Hazır",
  'apps.dk.stat.downloads': "İndirme",
  'apps.dk.stat.rating': "Puan",
  'apps.dk.stat.size': "Boyut",
  'apps.dk.stat.version': "Sürüm",
  'apps.dk.tag.customerManagement': "Müşteri yönetimi",
  'apps.dk.tag.expenseTracking': "Gider takibi",
  'apps.dk.tag.invoiceGeneration': "Fatura oluşturma",
  'apps.dk.tag.multiCurrency': "Çoklu para birimi",
  'apps.dk.tag.offlineFirst': "Çevrimdışı öncelikli",
  'apps.dk.tag.pdfExport': "PDF dışa aktarma",
  /* Defter kasa  */
  'apps.dk.value.downloads': "5", 
  'apps.dk.value.rating': "0★",
  'apps.dk.value.size': "23.9 MB",
  'apps.dk.value.version': "a1.0.1",
  /* Defter kasa  */
  'apps.exploreDesc': "Oyunlar bölümümüze de göz atın.",
  'apps.exploreMore': "// daha fazla keşfet",
  'apps.googlePlay': "Google Play",
  'apps.kg.description': "Düşünceleriniz ve rüyalarınız için kozmik temalı kişisel günlük.",
  'apps.kg.longDescription': "Kozmik Günlük, kozmik uzay temasıyla güzel tasarlanmış kişisel bir günlük uygulamasıdır. Günlük yazın ve kendi evreninizi kurun, ruh halinizi takip edin, zamanla duygusal kalıplarınızı keşfedin ve düşüncelerinizin yüreğinizde ağırlık yapmasına izin vermeyin. Yakında Google Play'de.",
  'apps.kg.name': "Kozmik Günlük",
  'apps.kg.progressLabel': "Tahmini çıkış tarihi: 2027",
  'apps.kg.stat.downloads': "İndirme",
  'apps.kg.stat.platform': "Platform",
  'apps.kg.stat.release': "Çıkış",
  'apps.kg.stat.status': "Durum",
  'apps.kg.stat.version': "Sürüm",
  'apps.kg.tag.cosmicThemes': "Kozmik temalar",
  'apps.kg.tag.dailyJournaling': "Günlük yazımı",
  'apps.kg.tag.darkUi': "Karanlık arayüz",
  'apps.kg.tag.encryptedEntries': "Şifreli girişler",
  'apps.kg.tag.moodTracking': "Ruh hali takibi",
  'apps.kg.tag.streakTracking': "Seri takibi",
  'apps.kg.value.release': "2027",
  'apps.kg.value.status': "In Development",
  'apps.kg.value.version': "v0",
  'apps.label': "// uygulamalar",
  'apps.live': "Canlı",
  'apps.title': "Uygulamalar",
  'apps.total': "Toplam Uygulama",
  'apps.viewDetails': "Detayları Gör",
  'apps.viewGames': "Oyunları Gör",
  'common.items': "öğe",
  'common.platform.android': "Android",
  'common.value.na': "—",
  'common.value.none': "Yok",
  'common.value.tbd': "Duyurulacak",
  'contact.copied': "✓ Kopyalandı",
  'contact.copy': "Kopyala",
  'contact.description': "Hata raporu, özellik isteği, ortaklık veya sadece sohbet etmek — her mesajı okuyoruz ve kişisel olarak yanıt veriyoruz.",
  'contact.err.emailInvalid': "Lütfen geçerli bir e-posta adresi girin.",
  'contact.err.emailRequired': "E-posta zorunludur.",
  'contact.err.messageRequired': "Mesaj zorunludur.",
  'contact.err.nameRequired': "Ad zorunludur.",
  'contact.form.email': "E-posta",
  'contact.form.emailPlaceholder': "eposta@adresiniz.com",
  'contact.form.error': "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  'contact.form.error.rateLimit': "Çok fazla deneme yapıldı. Lütfen birkaç dakika sonra tekrar deneyin.",
  'contact.form.footer': "Merak etmeyin, size gereksiz mailler göndermeyeceğiz. Sadece bize ilettiğiniz mesajlara cevap vereceğiz.",
  'contact.form.message': "Mesaj",
  'contact.form.messagePlaceholder': "Sorununuzu, fikrinizi veya sorunuzu açıklayın...",
  'contact.form.name': "Ad",
  'contact.form.namePlaceholder': "Adınız",
  'contact.form.product': "İlgili Ürün",
  'contact.form.required': "zorunlu",
  'contact.form.send': "Mesaj Gönder",
  'contact.form.sending': "Gönderiliyor...",
  'contact.form.state.ready': "HAZIR",
  'contact.form.state.sent': "GÖNDERİLDİ",
  'contact.form.subject': "Konu",
  'contact.form.subject.bug': "Hata Raporu",
  'contact.form.subject.feature': "Özellik İsteği",
  'contact.form.subject.general': "Genel Soru",
  'contact.form.subject.partnership': "Ortaklık",
  'contact.form.subject.website': "Web Sitesi İstiyorum",
  'contact.form.subtitle': "24 saat içinde geri döneceğiz.",
  'contact.form.title': "Mesaj Gönder",
  'contact.label': "// iletişim",
  'contact.product.defterkasa': "Defter Kasa",
  'contact.product.anilar': "Anılar Müzesi",
  'contact.product.general': "Genel / Diğer",
  'contact.product.kozmik': "Kozmik Günlük",
  'contact.step1': "Sorununuzu veya fikrinizi açıklayın",
  'contact.step2': "Formu doldurun veya bize e-posta gönderin",
  'contact.step3': "24 saat içinde yanıt alın",
  'contact.success.another': "Başka bir mesaj gönder →",
  'contact.success.body': "24 saat içinde yanıt vereceğiz.",
  'contact.success.thanks': "Ulaştığınız için teşekkürler.",
  'contact.success.title': "Mesaj Gönderildi!",
  'contact.title': "Merhaba",
  'contact.title.sub': "Deyin.",
  'dk.changelog.1.note': "PDF dışa aktarma, UI iyileştirmeleri, hata düzeltmeleri",
  'dk.changelog.2.note': "Jetpack Compose ile tam yeniden yazım",
  'dk.changelog.3.note': "Fatura oluşturma özelliği eklendi",
  'dk.changelog.4.note': "İlk sürüm",
  'dk.cta.play': "Google Play",
  'dk.cta.privacy': "Gizlilik Politikası",
  'dk.cta.windows': "Windows için indir",
  'dk.description': "Küçük işletmeler için profesyonel muhasebe ve ön muhasebe. Gelir, gider, fatura takibi.",
  'dk.f1.desc': "İnternetsiz çalışır. Tüm veriler cihazınızda yerel olarak saklanır. Bulut senkronizasyonu gerekmez, sunucu bağımlılığı yoktur.",
  'dk.f1.tag': "TEMEL",
  'dk.f1.title': "Tamamen Çevrimdışı",
  'dk.f2.desc': "Her müşterinin borç ve ödeme geçmişini takip edin. Temiz liste görünümüyle kimin ne kadar borçlu olduğunu bir bakışta görün.",
  'dk.f2.tag': "ÖZELLİK",
  'dk.f2.title': "Müşteri Defteri",
  'dk.f3.desc': "Saniyeler içinde profesyonel faturalar oluşturun. PDF olarak dışa aktarın ve doğrudan uygulamadan paylaşın.",
  'dk.f3.tag': "ÖZELLİK",
  'dk.f3.title': "Fatura Oluşturma",
  'dk.f4.desc': "Günlük gider ve gelirleri kaydedin. Basit özetlerle nakit akışınızı net bir şekilde görün.",
  'dk.f4.tag': "ÖZELLİK",
  'dk.f4.title': "Gider Takibi",
  'dk.f5.desc': "Analitik yok, reklam yok, veri toplama yok. Mali verileriniz cihazınızda kalır, nokta.",
  'dk.f5.tag': "GİZLİLİK",
  'dk.f5.title': "Gizlilik Öncelikli",
  'dk.f6.desc': ".NET MAUI ve C# ile yüksek performanslı, cross-platform native deneyim için geliştirildi.",
  'dk.f6.tag': "TEKNİK",
  'dk.f6.title': "Performance",
  'dk.features.label': "// özellikler",
  'dk.footer.left': "defter-kasa · a1.0.1 — kararlı",
  'dk.footer.right': "Finans · Android · Çevrimdışı",
  'dk.meta': "a1.0.1 · Finans · Android",
  'dk.mock.recentTransactions': "Son İşlemler",
  'dk.mock.thisMonth': "Bu ay +₺4,750",
  'dk.mock.totalBalance': "Toplam Bakiye",
  'dk.mock.tx1.name': "Ahmet Yılmaz",
  'dk.mock.tx2.name': "Fatura #0042",
  'dk.mock.tx3.name': "Gider Kaydı",
  'dk.mock.tx4.name': "Mehmet Demir",
  'dk.mock.tx5.name': "Ayşe Kaya",
  'dk.name': "Defter Kasa",
  'dk.name.line1': "Defter",
  'dk.name.line2': "Kasa",
  'dk.nav.download': "İndir",
  'dk.nav.features': "Özellikler",
  'dk.nav.specs': "Teknik",
  'dk.privacy.back': "Geri",
  'dk.privacy.breadcrumb.privacy': "Gizlilik",
  'dk.privacy.breadcrumb.products': "Ürünler",
  'dk.privacy.cta.desc': "Bu politika ile ilgili sorularınız için aşağıdaki kanalları kullanabilirsiniz.",
  'dk.privacy.cta.email': "info@g-software.org",
  'dk.privacy.cta.github': "GitHub: altusparati",
  'dk.privacy.cta.question': "// sorularınız mı var?",
  'dk.privacy.intro': "Defter Kasa, işletme ve müşteri kayıtlarını daha düzenli takip etmeyi hedefleyen bir cari takip uygulamasıdır. Bu politika; uygulama kullanılırken hangi bilgilere erişildiğini, bu bilgilerin nasıl işlendiğini ve izinlerin hangi amaçla kullanıldığını açıklar.",
  'dk.privacy.lastUpdated': "Son güncelleme: 23 Mart 2026",
  'dk.privacy.s01.content': "Defter Kasa, kullanıcı tarafından oluşturulan işletme, müşteri, borç, ödeme ve not kayıtlarını yönetmek için tasarlanmıştır. Amaç, günlük iş takibini hızlı ve anlaşılır tutmaktır.",
  'dk.privacy.s01.isList': "false",
  'dk.privacy.s01.title': "Genel yaklaşım",
  'dk.privacy.s02.item0': "Uygulama içinde oluşturduğunuz kayıtlar cihazınızda yerel olarak saklanır.",
  'dk.privacy.s02.item1': "Yedek alma veya geri yükleme sırasında seçtiğiniz dosyalar yalnızca bu işlemleri gerçekleştirmek için kullanılır.",
  'dk.privacy.s02.item2': "Kredi kartı bilgileri rutin uygulama kullanımı kapsamında toplanmaz veya saklanmaz.",
  'dk.privacy.s02.title': "Toplanan ve saklanan bilgiler",
  'dk.privacy.s03.item0': "Kamera izni yalnızca sizin açık tercihinizle fotoğraf çekebilmeniz için kullanılır.",
  'dk.privacy.s03.item1': "Galeri veya dosya seçme erişimi, kayıtlara görsel eklemek istediğiniz durumlarda devreye girer.",
  'dk.privacy.s03.item2': "Seçtiğiniz görseller ilgili kayıtlarla ilişkilendirilmek üzere cihazınızda saklanır.",
  'dk.privacy.s03.title': "Kamera ve görsel erişimi",
  'dk.privacy.s04.item0': "Bildirim izni, yaklaşan veya vadesi gelen kayıtlar için hatırlatma göndermek amacıyla kullanılabilir.",
  'dk.privacy.s04.item1': "PIN veya biyometrik kilit gibi güvenlik özellikleri, cihazınızdaki uygulama erişimini korumak için kullanılır.",
  'dk.privacy.s04.title': "Bildirimler ve güvenlik",
  'dk.privacy.s05.item0': "Abonelik veya ödeme işlemleri sunuluyorsa bunlar Google Play altyapısı üzerinden yürütülür.",
  'dk.privacy.s05.item1': "Mağaza, işletim sistemi veya seçilen yedekleme kanalları kendi gizlilik politikalarını ayrıca uygulayabilir.",
  'dk.privacy.s05.title': "Ödeme ve platform hizmetleri",
  'dk.privacy.s06.item0': "G-Soft, rutin kullanım kapsamında ticari kayıtları kendi sunucularına aktarmayı amaçlamaz.",
  'dk.privacy.s06.item1': "Kişisel verileriniz satılmaz.",
  'dk.privacy.s06.item2': "Yasal zorunluluklar veya sizin açık işlemleriniz dışında veri paylaşımı hedeflenmez.",
  'dk.privacy.s06.title': "Veri paylaşımı",
  'dk.privacy.summary.0': "Veriler cihazda saklanır",
  'dk.privacy.summary.1': "Kişisel veri satılmaz",
  'dk.privacy.summary.2': "Kamera izni isteğe bağlı",
  'dk.privacy.summary.3': "Google Play altyapısı",
  'dk.privacy.summary.title': "Özet",
  'dk.privacy.title': "Gizlilik Politikası",
  'dk.progress.label': "Geliştirme İlerlemesi",
  'dk.progress.stable': "a1.0.1 — kararlı",
  'dk.progress.status': "Üretime Hazır",
  'dk.specs.appInfo': "Uygulama Bilgisi",
  'dk.specs.changelog': "Değişiklik Günlüğü",
  'dk.specs.cta': "Google Play'den İndir",
  'dk.specs.download': "İndir",
  'dk.specs.label': "// teknik özellikler",
  'dk.status': "CANLI",
  'footer.copyright': "© {{year}} G-Software · Tüm hakları saklıdır.",
  'footer.nav.contact': "İLETİŞİM",
  'footer.nav.products': "Ürünler",
  'footer.nav.stack': "Teknoloji",
  'footer.navigation': "Navigasyon",
  'footer.product.defterkasa.meta': "Finans · Android · CANLI",
  'footer.product.defterkasa.name': "Defter Kasa",
  'footer.product.kozmik.alt': "Kozmik Günlük logosu",
  'footer.product.kozmik.meta': "Yaşam Tarzı · Android - iOS · Yapım Aşaması",
  'footer.product.kozmik.name': "Kozmik Günlük",
  'footer.products': "Ürünler",
  'footer.systemStatus': "Tüm sistemler çalışıyor",
  'footer.tagline': "Gizlilik odaklı, çevrimdışı çalışan mobil uygulamalar. Bulut yok, takip yok, gereksizlik yok.",
  'footer.values': "Gizlilik Öncelikli · Çevrimdışı Öncelikli · Açık Kaynak",
  'games.am.category': "Atmosfer & Hikâye · Mobil",
  'games.am.description': "Atmosfer ve hikâye odağında tasarlanan, aktif geliştirme hattından çıkarılmış mobil oyun konsepti.",
  'games.am.longDescription': "Anılar Müzesi aktif üretim hattından çıkarıldı ve geliştirmesi durduruldu. Bu sayfa, projenin neden aktif katalogda yer almadığını arşiv kaydı olarak belgelemektedir.",
  'games.am.name': "Anılar Müzesi",
  'games.am.progressLabel': "İptal edildi",
  'games.am.stat.platform': "Platform",
  'games.am.stat.release': "Çıkış",
  'games.am.stat.status': "Durum",
  'games.am.stat.version': "Sürüm",
  'games.am.statValue.status': "İptal",
  'games.am.tag.archive': "Arşiv",
  'games.am.tag.atmosphere': "Atmosfer",
  'games.am.tag.mobile': "Mobil",
  'games.am.tag.storyDriven': "Hikâye odaklı",
  'games.archive.description': "Aktif geliştirme hattından çıkarılmış ve arşiv kaydı olarak korunan projeler.",
  'games.archive.label': "// arşiv",
  'games.archive.notInCatalog': "mevcut katalogda değil",
  'games.archive.note.0': "Aktif geliştirme bulunmuyor.",
  'games.archive.note.1': "Mağaza yayını veya yeni sürüm planı bulunmuyor.",
  'games.archive.note.2': "Eski ürün notları arşiv kaydı olarak korunuyor.",
  'games.archive.note.3': "Fikir ileride yeni bir projeye dönüşürse ayrı bir sayfa açılacak.",
  'games.archive.notesLabel': "// arşiv notları",
  'games.archive.record': "Arşiv Kaydı",
  'games.description': "Geliştirme aşamasındaki mobil oyunlar. Minimalist tasarım, derin mekanikler, tamamen çevrimdışı. Reklam yok, ödeme duvarı yok.",
  'games.devProgress': "Geliştirme İlerlemesi",
  'games.download': "İndir",
  'games.exploreDesc': "Üretkenlik uygulamalarımıza da göz atın.",
  'games.exploreMore': "// daha fazla keşfet",
  'games.inDevelopment': "Geliştirme Aşamasında",
  'games.label': "// oyunlar",
  'games.live': "Canlı",
  'games.status.cancelled': "İPTAL EDİLDİ",
  'games.title': "Oyunlar",
  'games.total': "Toplam Oyun",
  'games.viewApps': "Uygulamaları Gör",
  'games.viewDetails': "Detayları Gör",
  'hero.cta.github': "GitHub",
  'hero.cta.products': "Ürünleri Gör",
  'hero.description': "Gizlilik, performans ve temiz kullanıcı deneyimine odaklanarak mobil uygulamalar tasarlıyor ve geliştiriyoruz.",
  'hero.footer.tags': "Android - iOS · Gizlilik · Açık Kaynak",
  'hero.footer.version': "a1.0.1 — kararlı",
  'hero.label': "// bağımsız yazılım stüdyosu",
  'hero.stats.apps': "Canlı Uygulama",
  'hero.stats.downloads': "İndirme",
  'hero.stats.rating': "Ort. Puan",
  'hero.typed.0': "çevrimdışı çalışır.",
  'hero.typed.1': "size saygı duyan.",
  'hero.typed.2': "her zaman kullanıcının yanında.",
  'hero.typed.3': "kalıcı inşa edilmiş.",
  'hero.typed.4': "sizin için tasarlandı.",
  'kg.breadcrumb': "Kozmik Günlük",
  'kg.cta.features': "Özellikleri Keşfet",
  'kg.cta.soon': "Yakında",
  'kg.description': "Kozmik Günlük, kullanıcıların duygularını, düşüncelerini ve anılarını yaratıcı biçimde ifade edebileceği görsel odaklı bir dijital günlük uygulamasıdır. Yazı tamamlandığında metin yıldızlara, ışık izlerine ve kozmik detaylara dönüşür; her giriş kişisel evrende kalıcı bir iz bırakır.",
  'kg.f1.desc': "Düşüncelerinizi her gün güzel bir kozmik arayüzde yazın. Ruh hali göstergeleri ve zaman damgalarıyla zengin metin desteği.",
  'kg.f1.tag': "TEMEL",
  'kg.f1.title': "Günlük Yazma",
  'kg.f2.desc': "Kozmik ruh hali göstergeleriyle duygusal yolculuğunuzu takip edin. Zaman içinde zihinsel sağlığınızdaki kalıpları görselleştirin.",
  'kg.f2.tag': "ÖZELLİK",
  'kg.f2.title': "Ruh Hali Takibi",
  'kg.f3.desc': "Yazdıkça kendi evreninizi oluşturun. Kendi galaksileriniz, kendi güneş sistemleriniz. Her şey size bağlı, koca bir evren parmaklarınızın ucunda ve KALBİNİZDE.",
  'kg.f3.tag': "ÖZELLİK",
  'kg.f3.title': "Kozmik Oluşum",
  'kg.f4.desc': "Özel düşünceleriniz özel kalır. Yazdığınız en ufak bir nokta bile tarafımızca görülmez, yazılarınız kendi cihazınızda yerel olarak depolanır.",
  'kg.f4.tag': "GİZLİLİK",
  'kg.f4.title': "Günlük Güvenliği",
  'kg.f5.desc': "Günlük serilerle yazma alışkanlığı oluşturun. Kozmik yıldızlar toplayın ve günlük yazarken başarımlar açın.",
  'kg.f5.tag': "OYUNLAŞTIRMA",
  'kg.f5.title': "Seri Sistemi",
  'kg.f6.desc': "Yüreğinizdeki sıkıntılarınız yeterince size yük oluyorken bir de biz yük olmak istemiyoruz. Bu nedenle cihazınızda günlüğünüzü en akıcı şekilde kullanmanız için uygulamayı en iyi performans alabileceğiniz şekilde tasarlıyoruz.",
  'kg.f6.tag': "TEKNİK",
  'kg.f6.title': "Performans",
  'kg.features.label': "// özellikler",
  'kg.footer.left': "kozmik-gunluk · geliştirme",
  'kg.footer.right': "Yaşam Tarzı · Android - iOS · Kozmik",
  'kg.meta': "v0 · Yaşam Tarzı · Android - iOS",
  'kg.mock.appShortName': "Kozmik",
  'kg.mock.day': "Gün 7",
  'kg.mock.entry1.mood': "✦ Sakin",
  'kg.mock.entry1.title': "Sabah yürüyüşü",
  'kg.mock.entry2.mood': "✦ İlhamlı",
  'kg.mock.entry2.title': "Yeni fikirler",
  'kg.mock.entry3.mood': "✦ Huzurlu",
  'kg.mock.entry3.title': "Gün sonu",
  'kg.mock.entry4.mood': "✦ Gizemli",
  'kg.mock.entry4.title': "Rüya notu",
  'kg.mock.recentEntries': "Son Girişler",
  'kg.mock.starsCollected': "142 yıldız toplandı",
  'kg.mock.today': "Bugün",
  'kg.name': "Kozmik Günlük",
  'kg.name.line1': "Kozmik",
  'kg.name.line2': "Günlük",
  'kg.nav.features': "Özellikler",
  'kg.nav.notify': "Bildir",
  'kg.nav.specs': "Teknik",
  'kg.notify.btn': "Haberdar Et",
  'kg.notify.desc': "Kozmik Günlük şu anda geliştirme aşamasında. E-postanı bırak, beta programına dahil ol ve günlük yazmaya ilk sen başla. Uygulama yayınlandığı an da ilk senin haberin olsun.",
  'kg.notify.err.invalid': "Lütfen geçerli bir e-posta adresi girin.",
  'kg.notify.err.required': "E-posta adresi zorunludur.",
  'kg.notify.error': "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  'kg.notify.error.rateLimit': "Çok fazla deneme yapıldı. Lütfen birkaç dakika sonra tekrar deneyin.",
  'kg.notify.footer': "Spam yok. Yayınlandığında tek bir e-posta. Hepsi bu.",
  'kg.notify.label': "// Haberdar Ol",
  'kg.notify.placeholder': "eposta@adresin.com",
  'kg.notify.sending': "Gönderiliyor...",
  'kg.notify.stat.launch': "Hedef Lansman",
  'kg.notify.stat.launchVal': "2027",
  'kg.notify.stat.platform': "Platform",
  'kg.notify.stat.platformVal': "Android - iOS",
  'kg.notify.stat.price': "Fiyat",
  'kg.notify.stat.priceVal': "Ücretsiz",
  'kg.notify.sublabel': "Lansman Bildirimi",
  'kg.notify.success.another': "Başka e-posta ekle",
  'kg.notify.success.desc': "Kozmik Günlük hazır olur olmaz sana ulaşacağız.",
  'kg.notify.success.title': "Listedesin!",
  'kg.notify.title': "Kozmik bulutlara ilk sen",
  'kg.notify.title.accent': "dokun",
  'kg.progress.label': "Geliştirme İlerlemesi",
  'kg.progress.status': "Tahmini çıkış tarihi: 2027",
  'kg.progress.version': "geliştirme aşamasında",
  'kg.roadmap.1.note': "Temel günlük özellikleriyle ilk sürüm",
  'kg.roadmap.2.note': "Beta test aşaması, hata düzeltmeleri, performans iyileştirmeleri",
  'kg.roadmap.3.note': "Ruh hali takibi ve kozmik temalarla özel beta",
  'kg.roadmap.4.note': "Alfa sürümü, temel günlük işlevselliği",
  'kg.roadmap.current': "Mevcut",
  'kg.specs.appInfo': "Uygulama Bilgisi",
  'kg.specs.betaAccess': "Beta Erişimi",
  'kg.specs.betaDesc': "Kozmik Günlük'e erken erişim ister misiniz? Beta programımıza katılın ve kozmosa ilk keşfedenler arasında olun.",
  'kg.specs.joinWaitlist': "Bekleme Listesine Katıl",
  'kg.specs.label': "// teknik özellikler",
  'kg.specs.roadmap': "Yol Haritası",
  'kg.status': "Geliştirme Aşamasında",
  'lang.en': "İngilizce",
  'lang.tr': "Türkçe",
  'nav.apps': "Uygulamalar",
  'nav.contact': "İLETİŞİM",
  'nav.games': "Oyunlar",
  'nav.home': "Ana Sayfa",
  'nav.notify': "Bildir",
  'nav.stack': "TEKNOLOJİ",
    'nav.websiteOffer': "Web sitesi mi istiyorsunuz?",
    'websvc.label': "// web tasarım hizmeti",
    'websvc.title.line1': "Markanıza yakışan,",
    'websvc.title.accent': "müşteri getiren web siteleri.",
    'websvc.subtitle': "Ziyaretçi geldiğinde güven veren, hızlı açılan ve 'iletişime geç' dedirten web deneyimleri tasarlıyoruz.",
    'websvc.lead': "Bizim için web sitesi sadece güzel görünmek değil; markanızı doğru anlatmak, doğru kişiyi yakalamak ve talebe çevirmektir.",
    'websvc.metrics.label': "premium standart",
    'websvc.metric.1.label': "ilk 3 sn",
    'websvc.metric.1.value': "güven + netlik",
    'websvc.metric.2.label': "mobil uyum",
    'websvc.metric.2.value': "akıcı deneyim",
    'websvc.metric.3.label': "ticari hedef",
    'websvc.metric.3.value': "talep odaklı",
    'websvc.value.label': "neden bizimle yapılmalı",
    'websvc.value.title': "Karar vermeyi kolaylaştıran yapı",
    'websvc.value.1': "Markanızı premium gösteren temiz ve güçlü görsel dil",
    'websvc.value.2': "Ziyaretçiyi yormayan, adım adım yönlendiren kullanıcı akışı",
    'websvc.value.3': "Hizmetinizi kısa sürede anlaşılır kılan içerik kurgusu",
    'websvc.value.4': "Telefon, tablet ve masaüstünde tutarlı performans",
    'websvc.value.5': "Doğru yerde doğru CTA ile daha fazla iletişim talebi",
    'websvc.pitch.label': "g-software yaklaşımı",
    'websvc.pitch.title': "Siteniz vitrin olmaktan çıkar, çalışan bir satış kanalına dönüşür.",
    'websvc.pitch.body': "Her başlık, her buton ve her bölüm rastgele değil; kullanıcı psikolojisine göre planlanır. Böylece ziyaretçi sadece bakmaz, aksiyona geçer.",
    'websvc.pitch.result': "SONUÇ: PREMIUM ALGI + DAHA FAZLA NİTELİKLİ BAŞVURU",
    'websvc.services.label': "neler teslim ediyoruz",
    'websvc.card.1.title': "Konumlama ve Plan",
    'websvc.card.1.body': "Önce işinizi dinliyoruz. Hedef kitlenize uygun site stratejisini netleştiriyoruz.",
    'websvc.card.2.title': "UI/UX Tasarım",
    'websvc.card.2.body': "Markanızla uyumlu, sade ve güven veren arayüzleri detaylı şekilde tasarlıyoruz.",
    'websvc.card.3.title': "Modern Geliştirme",
    'websvc.card.3.body': "Hızlı, mobil uyumlu ve sürdürülebilir teknik altyapıyla sitenizi uçtan uca geliştiriyoruz.",
    'websvc.card.4.title': "Yayın ve İyileştirme",
    'websvc.card.4.body': "Yayına çıktıktan sonra veriye göre optimize ederek etkiyi sürekli artırıyoruz.",
    'websvc.process.label': "çalışma akışı",
    'websvc.step.1.title': "Tanışma ve Hedef",
    'websvc.step.1.body': "İş modelinizi, beklentinizi ve siteden almak istediğiniz sonucu netleştiriyoruz.",
    'websvc.step.2.title': "Tasarım ve Yapım",
    'websvc.step.2.body': "Onaylanan görsel dili performans odaklı kod yapısıyla canlıya hazır hale getiriyoruz.",
    'websvc.step.3.title': "Yayın ve Büyüme",
    'websvc.step.3.body': "Geri bildirim ve verilerle birlikte iyileştirmeleri yapıp sitenizi yayına alıp size teslim ediyoruz.",
    'websvc.finalCta': "Hemen iletişime geçin ve web sitenizi tasarlamaya başlayalım.",
    'websvc.finalSub': "Hazırsanız bir mesaj bırakın; size özel yol haritasını birlikte çıkaralım.",
    'websvc.cta': "Hemen İletişime Geç",
  'product.back': "Geri",
  'product.breadcrumb.products': "Ürünler",
  'products.archive.notInCatalog': "mevcut katalogda değil",
  'products.archive.record': "Arşiv Kaydı",
  'products.comingSoon': "Yakında",
  'products.googlePlay': "Google Play",
  'products.inDevelopment': "Geliştirme Aşamasında",
  'products.items': "ürün",
  'products.label': "// ürünler",
  'products.progress': "İlerleme",
  'products.status.cancelled': "İPTAL EDİLDİ",
  'products.status.dev': "Geliştirme Aşamasında",
  'products.status.live': "CANLI",
  'products.status.soon': "YAKINDA",
  'products.tab.apps': "Uygulamalar",
  'products.tab.games': "Oyunlar",
  'products.viewAll': "Tümünü Gör",
  'products.viewDetails': "Detayları Gör",
  'social.email': "E-posta",
  'social.github': "GitHub",
  'social.instagram': "Instagram",
  'social.x': "X",
  'social.tiktok': "TikTok",
  'social.toggle': "Sosyal Medya",
  'stack.label': "// nasıl inşa ediyoruz",
  'stack.p1.body': "Geliştirdiğimiz her uygulama yerel önceliklidir. Verileriniz, siz açıkça senkronizasyon seçmediğiniz sürece cihazınızdan çıkmaz. Analitik yok, takip yok, reklam yok.",
  'stack.p1.tag': "TEMEL İLKE",
  'stack.p1.title': "Tasarımla Gizlilik",
  'stack.p2.body': "İnternet bağlantısı isteğe bağlı olmalı, zorunlu değil. Uygulamalarımız tamamen çevrimdışı çalışır ve bağlantı olduğunda senkronize olur.",
  'stack.p2.tag': "MİMARİ",
  'stack.p2.title': "Çevrimdışı Öncelikli",
  'stack.p3.body': "UI detaylarına takıntılıyız. Her piksel, her animasyon, her etkileşim kasıtlıdır. İyi tasarım görünmezdir.",
  'stack.p3.tag': "TASARIM",
  'stack.p3.title': "Temiz Arayüzler",
  'stack.p4.body': "Şeffaflık güven inşa eder. Sizden hangi bilgilerin talep edildiği ve hangi bilgileriniz kullanıldığı her mobil uygulamamızın gizlilik politikasında belirtilmiştir.",
  'stack.p4.tag': "FELSEFİ",
  'stack.p4.title': "Güven",
  'stack.techLabel': "// teknoloji yığını",
};
